import ApiService from '../services/api';

const STORAGE_KEY = 'pendingSupplierInvite';

export function storePendingSupplierInvite(token: string) {
  try {
    sessionStorage.setItem(STORAGE_KEY, token);
  } catch {
    // ignore
  }
}

export function peekPendingSupplierInvite(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearPendingSupplierInvite() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

/**
 * After supplier registration/onboarding, link the pending buyer invite once.
 */
export async function acceptPendingSupplierInviteIfAny(): Promise<{
  accepted: boolean;
  message?: string;
}> {
  const token = peekPendingSupplierInvite();
  if (!token) {
    return { accepted: false };
  }
  try {
    const response = await ApiService.acceptSupplierEnrollmentInvite(token);
    clearPendingSupplierInvite();
    if (!response?.success) {
      return { accepted: false, message: response?.message };
    }
    return {
      accepted: true,
      message: response.message || 'Supplier enrollment linked to the buyer invite.',
    };
  } catch (error) {
    // Keep token for retry unless invite is gone/expired/self.
    const message = error instanceof Error ? error.message : '';
    if (/not found|expired|own company|forbidden/i.test(message)) {
      clearPendingSupplierInvite();
    }
    return { accepted: false, message };
  }
}
